
import React from 'react'
import PropTypes from 'prop-types'
import { StepperTypeForStepSwitch } from './StepperType'
import { get } from 'lodash-es'

const VALID_CHILD_TYPES = ['Step', 'StepList', 'StepSwitch', 'StepGo']

class StepSwitch extends React.Component {
  static displayName = 'StepSwitch'

  indexInStepList: number
  currentChildRef: any

  static propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    name: PropTypes.string,
    stepper: StepperTypeForStepSwitch,
    children: PropTypes.node,
  }

  constructor(props) {
    super(props)
    this.validateSwitchStepIdentifier(props)
    React.Children.forEach(props.children, (child) => {
      this.validateChildType(child)
    })
    this.indexInStepList = (props as any).stepper.switchStepIdentifier.index
  }

  validateSwitchStepIdentifier(props) {
    if (
      typeof get(props, 'stepper.switchStepIdentifier.index') !== 'number' ||
      typeof get(props, 'stepper.switchStepIdentifier.name') !== 'string'
    ) {
      throw new Error(`Invalid switchStepIdentifier stored in stepper`)
    }
  }

  validateChildType(child) {
    const childName = child.type.displayName
    if (!VALID_CHILD_TYPES.includes(childName)) {
      throw new Error(`Invalid StepList child type '${childName}'`)
    }

    if (!child.props.default && !child.props.name) {
      throw new Error(`Missing name or default attribute in ${childName} element`)
    }
  }

  getCurrentChildRef() {
    return this.currentChildRef
  }

  validateRender(switchStepName, element) {
    let msg
    if (!element) {
      if (switchStepName) {
        msg = `Child element with '${switchStepName}' name not found in StepSwitch`
      } else {
        msg = 'Child element not found found in StepSwitch, missing default Step.'
      }
      throw new Error(msg)
    }
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { name, stepper, children, ...rest } = this.props as any

    if (this.indexInStepList !== stepper.getCurrentStepIndex()) {
      // don't render other StepSwitches (if any)
      return null
    }

    const element = React.Children.toArray(children).find((child: any) => {
      const { name: switchStepName } = stepper.switchStepIdentifier

      return (
        switchStepName === child.props.name || (child.props.default && switchStepName === 'default')
      )
    })
    this.validateRender(stepper.switchStepIdentifier.name, element)

    this.currentChildRef = React.createRef()

    return React.cloneElement(element as any, {
      stepper,
      ref: this.currentChildRef,
      ...rest,
    })
  }
}

export default StepSwitch
